import actions from './actions'

export default function CostTypeDefinitionsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_COSTTYPEDEFINITION:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_COSTTYPEDEFINITION:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_COSTTYPEDEFINITION:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_COSTTYPEDEFINITION:
      return {
        ...state,
        editing: { definitionID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_COSTTYPEDEFINITION_RECIEVED ||
      actions.UPDATE_COSTTYPEDEFINITION_RECIEVED ||
      actions.DELETE_COSTTYPEDEFINITION_RECIEVED:
      return {
        ...state,
        editing: { definitionID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
